import React from 'react';
import {
  View,
  StyleSheet,
} from 'react-native';
import type { OrderWidgetProps } from './types';
import { MetisTool } from '../../tools/MetisTool';

/**
 * MetisWidget renders the full METIS agenda tool inside the EXECUTE section.
 * The tool manages its own scrolling and layout; this widget only provides
 * the container with proper height and styling.
 */
export function MetisWidget({ userId, gear, data, onOpen }: OrderWidgetProps) {
  return (
    <View style={styles.container}>
      <MetisTool
        sector="S"
        stage="T"
        gear={gear}
        onOpenTool={onOpen}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  // Height/clipping only — MetisTool draws its own AGENDA panel, so any
  // background or shadow here just stacks a second rectangle behind it.
  container: {
    overflow: 'hidden',
    minHeight: 520,
    flex: 1,
  },
});
